
$(document).ready(function () {
  $(document).on("keypress", "input[id^='choices-input_field_'], input[id^='choices_input_field_']", function (e) {
    if (e.which === 13) {
      e.preventDefault();
      e.stopPropagation();
      var val = $(this).val();
      if (!val) return;
      var container = $(this).closest('.input-container');
      var list = container.find('ul').first();
      var hidden = container.find('input[type="hidden"]').first();
      list.append("<li>" + val + "</li>");
      hidden.val((hidden.val() || "") + ("<" + val + ">"));
      $(this).val("");
    }
  });
  $(document).on('click', '.choise-field-delete', function () {
    var choice_name = $(this).data('choice');
    var container = $(this).closest('.input-container');
    var hidden = container.find('input[type="hidden"]').first();
    hidden.val((hidden.val() || "").replace("<" + choice_name + ">", ""));
    $(this).closest('li').remove();
  });
});
$(function () {
  $(document).on('change', '.kind', function () {
    var val = $(this).children('option:selected').val();
    var row = $(this).closest('.nested-fields');
    var group = row.find('.form-group').filter(function () {
      return $(this).find('.input-container').length > 0;
    }).first();
    var inputContainer = group.find('.input-container').first();
    var numberRestrictions = group.find('.number-restrictions-container').first();

    if (val == 'many_choices' || val == 'one_choice') {
      inputContainer.css('visibility', 'unset');
    } else {
      inputContainer.css('visibility', 'hidden');
    }
    if (val === 'number') {
      numberRestrictions.css({ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' });
    } else {
      numberRestrictions.hide();
    }
  });
});
$(function () {
  $(document).on('click', '.add_fields', function () {
    if ($(".kind").length > 0) {
      let id = parseInt($(".kind")[document.getElementsByClassName('kind').length - 2].id.split("_")[1], 10) + 1
      if (!id) {
        id = 0
      }
      $('#select-type_').attr('id', `select-type_${id}`)
      $('#choices-input_field_').attr('id', `choices-input_field_${id}`)
      $('#options-list-input_').attr('id', `options-list-input_${id}`)
      $('#options-list_').attr('id', `options-list_${id}`)
      $('#input-container-').attr('id', `input-container-${id}`)
      $('#number-restrictions-container-').attr('id', `number-restrictions-container-${id}`)
    }
  });
});
